/**
 * DS3 event listeners — push dataLayer events for GTM/GA4.
 *
 * Events sent to dataLayer:
 *   ds3_info_submit          ← HS form submit (DS3/index.js dispatches)
 *   ds3_scheduled            ← qualified Meeting Booked (also fires lintrk + Optimizely)
 *
 * Debug: ?thryvDebug=ds3 or ?thryvDebug=qualifiedEvents
 */
var DS3_Events = new Object();

DS3_Events.version = "1.0.0";

DS3_Events.listen = function ($el) {
	console.log("[DS3.Events] listen", $el);

	helpers.listenEvent("ds3_info_submit", function (detail) {
		// var nameArr = helpers.splitFullName(detail.full_name);
		// console.log('detail', detail);
		// console.log('nameArr', nameArr);
		var dataLayerData = helpers.dlSanitize({
			event: "ds3_info_submit",
			event_name: "ds3_info_submit",
			click_url: window.location.href,

			// User data (must match your GTM DLV variable names)
			fname: helpers.splitFullName(detail.full_name)["first"],
			lname: helpers.splitFullName(detail.full_name)["last"],
			email: detail.email,
			phone: detail.phone,

			// Extra identifiers
			// hubspot_id: formData.hubspotId,
			event_id: crypto.randomUUID(),
			page_url: window.location.href,

			// Meta cookies (already exist client-side, but you can send explicitly too)
			fbp: Cookies.get("_fbp"),
			fbc: Cookies.get("_fbc"),
		});

		if (helpers.shouldDebug("ds3"))
			console.log("[DS3.Events] ds3_info_submit dataLayerData:", dataLayerData);

		dataLayer.push(dataLayerData);

		window.lintrk && window.lintrk("track", { conversion_id: 10868140 });

		// TikTok Lead event
		window.ttq && window.ttq.track("Lead");

		window["optimizely"] = window["optimizely"] || [];
		window["optimizely"].push({
			type: "event",
			eventName: "Demo Info Submitted",
		});
	});
};

export default DS3_Events;
